<template>
  <div>
    <Layout title="Trial" />
    <AppButton @click="nextOnboardingPage">Continue</AppButton>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/app/components/button/AppButton.vue'

import Layout from '../Layout.vue'

defineProps<{
  nextOnboardingPage: () => void
}>()
</script>
